import React, { useRef, useState } from "react";
import { translate } from "../Services/translation";
import DealerEmailObfuscate from "./Dealer.EmailObfuscate";

const DealerCollapsible = ({ dealer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="dealer__collapsible">
      <div
        className={`dealer__collapsible-header ${isOpen ? "open" : ""}`}
        onClick={toggleCollapsible}
      >
        <div className="dealer__collapsible-header--left">
          {dealer.CompanyName}
        </div>
        {dealer.Distance && (
          <div
            className="dealer__collapsible-header--center"
            style={{ opacity: !isOpen ? "1" : "0" }}
          >
            <i className="bi bi-geo" />
            {dealer.Distance.text}
          </div>
        )}
        <div className="dealer__collapsible-header--right">
          <div className="dealer__collapsible-header-icons">
            <i
              className="bi bi-house-door"
              style={{ opacity: dealer.StreetAdress ? "1" : "0.05" }}
            />
            <i
              className="bi bi-bag"
              style={{ opacity: dealer.IsEcom ? "1" : "0.05" }}
            />
            <i
              className="bi bi-lock-fill"
              style={{ opacity: dealer.IsReqEcom ? "1" : "0.05" }}
            />
          </div>
          <div
            className={`dealer__collapsible-header-chevron ${
              isOpen ? "open" : ""
            }`}
          >
            <i className="bi bi-chevron-down" />
          </div>
        </div>
      </div>
      <div
        className="dealer__collapsible-body"
        ref={contentRef}
        style={{
          maxHeight: isOpen ? `${contentRef.current.scrollHeight}px` : "0",
        }}
      >
        <div className="dealer__collapsible-content">
          <div className="dealer__collapsible-content--left">
            {dealer.Phone && (
              <div className="dealer__collapsible-content-obj">
                <i className="bi bi-telephone" /> {dealer.Phone}
              </div>
            )}
            {dealer.Email && <DealerEmailObfuscate email={dealer.Email} />}
            {dealer.Website && (
              <a
                target="_blank"
                href={dealer.Website}
                className="dealer__collapsible-content-obj"
              >
                <i className="bi bi-globe" /> {dealer.Website}
              </a>
            )}
            {dealer.Coordinates && (
              <a
                target="_blank"
                href={`https://www.google.com/maps/dir/?api=1&destination=${dealer.Coordinates.replace(
                  / /g,
                  ""
                )}`}
                className="dealer__collapsible-content-obj"
              >
                <i className="bi bi-map" /> {translate("dealers.find-us")}
              </a>
            )}
          </div>
          <div className="dealer__collapsible-content--right">
            {dealer.StreetAdress &&
              dealer.City &&
              dealer.ZipCode &&
              dealer.GoogleMapsLink && (
                <a
                  target="_blank"
                  href={dealer.GoogleMapsLink}
                  className="dealer__collapsible-content-obj"
                >
                  <i className="bi bi-house-door" />
                  <div>
                    <div>{dealer.CompanyName}</div>
                    <div>{dealer.StreetAdress}</div>
                    <div>
                      {dealer.ZipCode} {dealer.City}
                    </div>
                  </div>
                </a>
              )}
            {dealer.Distance && (
              <div
                className="dealer__collapsible-content-obj"
                style={{ opacity: isOpen ? "1" : "0" }}
              >
                <i className="bi bi-geo" />
                {dealer.Distance.text}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealerCollapsible;
